import { css, SerializedStyles } from '@emotion/react'
import { ObjectFit } from './types'

const base = (imageFit: ObjectFit): SerializedStyles =>
  css({
    height: '100%',
    objectFit: imageFit,
    width: '100%',
  })

export const styles = { base }
